import { dispatch } from "../redux/store";
import { logoutAction } from "../redux/userSlice";
import { postRequest } from "./axios";


export const login = async (uid = "", password = "") => {

    try {

        const result = await postRequest("/users/login", {uid, password});

        return result; 

    } catch(e) {

        throw new Error("Errore durante il login: " + e); 

    }

}

export const logout = async (token: string | null = "") => {

    dispatch(logoutAction()); 

}
 
export const checkToken = async (token = "") => {

    try {

        const result = await postRequest("/users/get_current_user", { token }); 

        return result; 

    } catch(e) {

        throw new Error("Impossibile verificare il token: " + e); 

    }

}